import React, { useEffect } from "react";
import Block from "./Block";
import { styled } from "../stitches.config";
import { AnyBlock } from "../types";
import { blockSelectionAtom, blockYouJustCreatedAtom } from "../jotai/atoms";
import { useAtom } from "jotai";

function BlockList({
  blockIds,
  deleteBlock,
  upsertBlock,
}: {
  blockIds: string[];
  deleteBlock: (blockId: string) => void;
  upsertBlock: (b: AnyBlock) => void;
}) {
  const [selection, select] = useAtom(blockSelectionAtom);
  const [justCreated] = useAtom(blockYouJustCreatedAtom);

  // Set up key listeners and canvas listeners
  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      switch (e.key) {
        case "Backspace":
        case "Delete":
          if (!selection) break;
          if (document.activeElement?.tagName === "TEXTAREA") break;
          if (document.activeElement?.tagName === "INPUT") break;
          e.preventDefault(); // Prevent page back
          selection.forEach((id: string) => {
            deleteBlock(id);
          });

          select({ type: "clear" });
          break;
        case "Escape":
          select({ type: "clear" });

          break;
        default:
      }
    }

    function deselectIfNotBlock(e: MouseEvent) {
      let cursor = e.target as Element;

      while (cursor) {
        if (cursor.className?.includes?.("block")) {
          return;
        }
        cursor = cursor.parentElement as Element;
      }
      select({ type: "clear" });
    }

    window.addEventListener("keydown", onKeyDown);
    document.addEventListener("mousedown", deselectIfNotBlock);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("mousedown", deselectIfNotBlock);
    };
  }, [blockIds, deleteBlock, select, selection]);

  return (
    <BlockWrapper>
      {blockIds.map((id: string) => {
        return (
          <Block
            key={id}
            id={id}
            selected={selection.has(id)}
            justCreated={justCreated === id}
            upsertBlock={upsertBlock}
            deleteBlock={deleteBlock}
          ></Block>
        );
      })}
    </BlockWrapper>
  );
}

export default BlockList;

const BlockWrapper = styled("ul", {
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  pointerEvents: "none", // remove hack later
});
